import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps, Option } from '@/app/components/search/components/Form';
import type { AccommodationThemes } from '../../../../../utils/api/filtersAPIResponseTypes';
import { getMultilistboxValue, OPTIONS_SORT } from '../../utils';
import type { CommonProps } from '../CommonProps';
import getListboxContainer from '../getListboxContainer';
import getSearchListContainer from '../getSearchListContainer';
import { isObject } from '../../../../../Utilities';

export const getAccommodationThemesOptions = ({
  accommodationThemes,
  isWaiting,
  t,
}: {
  accommodationThemes?: AccommodationThemes | undefined;
  isWaiting: boolean;
  t: TranslationFunction;
}): Option[] => {
  if (!accommodationThemes || !isObject(accommodationThemes)) return [];

  // The feed owns the theme vocabulary and keeps adding to it, so the published copy is what
  // decides which themes are offered: an unlabelled checkbox is still clickable.
  return Object.keys(accommodationThemes).reduce<Option[]>((options, accommodationTheme) => {
    const label = t(`vacation.search.filters.trustyou.options.${accommodationTheme}`);
    if (!label) return options;

    const counter = accommodationThemes[accommodationTheme];
    options.push({
      value: accommodationTheme,
      label,
      addLabel: counter?.toString(),
      disabled: counter === 0 || isWaiting,
    });
    return options;
  }, []);
};

const getDynamicField = ({
  fieldName,
  containerName,
  containerTitle,
  options,
  param,
  commonProps,
  isSearchList,
  label,
  noResultsText,
  anyField,
}: {
  fieldName: string;
  containerTitle: string;
  containerName: string;
  options: Option[];
  param: string;
  commonProps: CommonProps;
  isSearchList?: boolean;
  label?: string;
  noResultsText?: string;
  anyField?: string;
}): ControlProps => {
  const value = getMultilistboxValue(param, false);
  if (isSearchList) {
    return getSearchListContainer({
      fieldName,
      containerName,
      containerTitle,
      label: label || '',
      options,
      value,
      noResultsText,
      anyField,
      ...commonProps,
    });
  }

  return getListboxContainer({
    fieldName,
    containerName,
    containerTitle,
    options,
    value,
    fieldClassName: '',
    optionsSort: OPTIONS_SORT.NUM,
    ...commonProps,
  });
};

export default getDynamicField;
